import env from "../utils/env";
import { prepareHyHttpHeaders } from "../utils/http";
import { createAbortableFetcher } from "../utils/abortable-fetcher";

export function createRecipesFetcher() {
  const [doFetch] = createAbortableFetcher(
    `${env("BASE_HY_NO_API_URL")}bigoven/recipes`,
    { headers: prepareHyHttpHeaders() }
  );
  return function formFetcher(searchParams) {
    return doFetch(searchParams);
  };
}

export function createRecipeFetcher(id) {
  const [doFetch] = createAbortableFetcher(
    `${env("BASE_HY_NO_API_URL")}bigoven/recipe/${id}`,
    { headers: prepareHyHttpHeaders() }
  );
  return function formFetcher() {
    return doFetch();
  };
}
